// Module
var code = "<span class=\"nowrap price-span\" ng-if=\"vm.budgetEstimate.priceExcludingVAT > 0\"> <cd-currency symbol/>&thinsp;{{ vm.budgetEstimate.priceExcludingVAT | number:2 }} </span> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-total-price.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;